import defaultAttributes from '../defaultAttributes';

const FileDiff = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z',
      },
    ],
    ['path', { d: 'M12 13V7' }],
    ['path', { d: 'M9 10h6' }],
    ['path', { d: 'M9 17h6' }],
  ],
];

export default FileDiff;
